import { createSlice } from '@reduxjs/toolkit';
import { getExceptionQueueThunk } from './ExceptionQueueActions';

export interface ExceptionQueueState {
  exceptionQueue: any[];
  loading: boolean;
}

const initialState: ExceptionQueueState = {
  exceptionQueue: [],
  loading: false,
};

const exceptionQueueSlice = createSlice({
  name: 'exceptionQueue',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExceptionQueueThunk.pending, (state) => {
      state.loading = true;
      state.exceptionQueue = [];
    });
    builder.addCase(getExceptionQueueThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.exceptionQueue = action.payload?.data?.exceptions || [];
    });
    builder.addCase(getExceptionQueueThunk.rejected, (state) => {
      state.loading = false;
      state.exceptionQueue = [];
    });
  },
});

export default exceptionQueueSlice.reducer;
